import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const updateGraduateInfo = listeners["updateGraduateInfo"] || function () { };
  const deleteLiaison = listeners["deleteLiaison"] || function () { };
  const updateLiaison = listeners["updateLiaison"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [];
    dealConf.push([
      "icon-edit",
      "编辑",
      () => updateLiaison(item),
      "group:liaison:update"
    ]);
    dealConf.push([
      "icon-graduation",
      "结业设置",
      () => updateGraduateInfo(item),
      "group:liaison:graduation"
    ]);
    dealConf.push([
      "icon-delete",
      "删除",
      () => deleteLiaison(item),
      "group:liaison:delete"
    ]);

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const UserName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goDetail(row)}>
        {row.userName}
      </div>
    );
  };

  const GradeStatus = ({ props: { vo } }) => {
    const row = vo.row;
    const flag = row.graduationStatus === 2
    return <div class={flag ? "base-hover-char" : ""} onClick={() => {
      flag && outSchoolDetail(row)
    }}>
      {row.graduationStatusName}
    </div>

  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      ...tableBaseProps("姓名", "liaisonName", "80"),
    },
    tableBaseProps("工作单位", "deptName", "m150"),
    tableBaseProps("单位及职务", "unitPosition", "m150"),
    tableBaseProps("浙政钉绑定状态", "bindStatusName", "m100"),
    {
      ...tableBaseProps("结业状态", "graduationStatusName", "80"),
    },
    {
      label: "培训天数",
      prop: "trainDays",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "房间号",
      prop: "roomNumber",
      width: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      width: "150",
      render: vo => <Deal vo={vo} />
    }
    
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
